import fs from 'fs';
import path from 'path';
import filedirname from '../lib/filedirname';
// When compiling with an esm setting __filename and friends do not exist. When
// compiling with a cjs setting import.meta.url does not exist. In order to
// support both output types via tsc, we borrow this alternative method
const [_, this_dirname] = filedirname();
export class CategoryGroups {
    static allGroups() {
        const categoryGroups = fs
            .readdirSync(path.join(this_dirname, '../../data/categoryGroups'))
            .filter((filename) => filename.endsWith('.json'))
            .map((filename) => CategoryGroups.getGroup(filename.replace('.json', '')));
        return categoryGroups;
    }
    static getGroup(groupId) {
        const categoryGroupData = JSON.parse(fs.readFileSync(path.join(this_dirname, `../../data/categoryGroups/${groupId}.json`)).toString());
        return categoryGroupData;
    }
    static applyCategoryGroup(biddingObject, categoryGroup, overwrite = false) {
        const categoryGroupData = CategoryGroups.getGroup(categoryGroup);
        Object.entries(categoryGroupData.bidding.vendors).forEach((vendor) => {
            const vendorName = vendor[0], vendorConfigCG = vendor[1];
            CategoryGroups.updateVendor(biddingObject, vendorConfigCG, vendorName, overwrite);
        });
        CategoryGroups.updateUnits(biddingObject);
    }
    static updateUnits(biddingObject) {
        if (!biddingObject.units)
            biddingObject.units = [];
        if (biddingObject.vendors == null)
            biddingObject.vendors = {};
        const existingUnits = new Set();
        biddingObject.units.forEach((unit) => existingUnits.add(unit.zone + '@' + unit.size));
        for (const vendor of Object.entries(biddingObject.vendors)) {
            const vendorBiddingObject = vendor[1];
            if (!(vendorBiddingObject.enabled === true)) {
                continue;
            }
            if (vendorBiddingObject.bidRequestConfigs != null) {
                for (const unit of vendorBiddingObject.bidRequestConfigs) {
                    if (!unit.zone || !unit.size) {
                        continue;
                    }
                    if (['preroll', 'midroll', 'postroll'].includes(unit.zone) || unit.size === 'video') {
                        continue;
                    }
                    const key = unit.zone + '@' + unit.size;
                    if (!existingUnits.has(key)) {
                        existingUnits.add(key);
                        biddingObject.units.push({
                            zone: unit.zone,
                            size: unit.size,
                        });
                    }
                }
            }
        }
    }
    static updateVendor(biddingObject, vendorConfigCategoryGroupData, vendorName, overwrite) {
        let vendorBiddingObject = biddingObject.vendors[vendorName];
        if (vendorBiddingObject == null) {
            vendorBiddingObject = { bidRequestConfigs: [], enabled: false };
            biddingObject.vendors[vendorName] = vendorBiddingObject;
        }
        vendorBiddingObject.enabled = vendorConfigCategoryGroupData.enabled ?? vendorBiddingObject.enabled;
        const bidRequestConfigsToAdd = [];
        if (vendorBiddingObject.bidRequestConfigs == null) {
            vendorBiddingObject.bidRequestConfigs = [];
        }
        else {
            if (!overwrite) {
                vendorBiddingObject.bidRequestConfigs.forEach((bid_req) => {
                    if (!(bid_req.generated === true)) {
                        bidRequestConfigsToAdd.push(bid_req);
                    }
                });
            }
        }
        if (vendorConfigCategoryGroupData != null) {
            if (vendorConfigCategoryGroupData.config)
                vendorBiddingObject.config = vendorConfigCategoryGroupData.config;
            if (vendorConfigCategoryGroupData.bidRequestConfigs != null) {
                vendorConfigCategoryGroupData.bidRequestConfigs.forEach((bid_req) => {
                    bid_req.generated = true;
                    bidRequestConfigsToAdd.push(bid_req);
                });
            }
        }
        vendorBiddingObject.bidRequestConfigs = bidRequestConfigsToAdd;
        if (vendorName === 'appnexus') {
            vendorBiddingObject.enableNative = true;
            vendorBiddingObject.enableOutstream = true;
        }
    }
}
//# sourceMappingURL=categoryGroups.js.map